import React from "react"
import { Link } from "gatsby" 
import LOGO from '../styles/components/logo.module.scss'
import SiteLogoFile from '../images/logo.svg'

const SiteLogo = (data) => {
    return (
        <Link to="/" className={LOGO.LOGO}>
            <img src={SiteLogoFile} alt='Gerwin Adwokat' />
        </Link>
    )
}


export default SiteLogo